import { emptySplitApi } from "./InjectionEndpoint";

const documentApi = emptySplitApi.injectEndpoints({
    
    endpoints: (build: any) => ({

        getDocument: build.query({
            query: ({idAzienda, idDocument}: any) => `/api/azienda/${idAzienda}/documento-aziendale/${idDocument}`,
            providesTags: ['agency']
        }),

        updateDocument: build.mutation({
            query: ({idAzienda, idDocument, formData}: {idAzienda: number, idDocument: number, formData:any}) => ({
                url: `/api/azienda/${idAzienda}/documento-aziendale/${idDocument}`,
                method: 'PUT',
                body: formData
            }),
            invalidatesTags: ['agency']
        }),

        addDocument: build.mutation({
            query: ({idAzienda, formData}: any) => ({
                url: `/api/azienda/${idAzienda}/documento-aziendale`,
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['agency']
        }),

        deleteDocument: build.mutation({
            query: ({idAzienda, idDocument}: {idAzienda: number, idDocument: number}) => ({
                url: `/api/azienda/${idAzienda}/documento-aziendale/${idDocument}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['agency']
        }),

        getFile: build.query({
            query: (props: any) => ({
                url: `/api/Azienda/${props.idAzienda}/documento-aziendale/${props.documentoAziendaleId}/file`,
                responseHandler: async (response: any) => {
                    const blob = await response.blob();
                    const fileURL = URL.createObjectURL(blob);
                    return { fileURL, fileName: response.headers.get('Content-Disposition') };
                },
                cache: "no-cache",
            }),
        }),

        downloadDocument: build.mutation({
            query: ({idAzienda, idDocument}: {idAzienda: number, idDocument: number}) => ({
                url: `/api/azienda/${idAzienda}/documento-aziendale/${idDocument}/file`,
                method: 'GET',
                responseHandler: async (response: Response): Promise<any> => {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    return url;
                }
            }),
            invalidatesTags: ['agency']
        }),

    }),
});

export const {
    useAddDocumentMutation,
    useUpdateDocumentMutation,
    useDeleteDocumentMutation,
    useGetFileQuery,
    useDownloadDocumentMutation,
    useGetDocumentQuery
} = documentApi;